import { Button, Field, FileUpload, Heading, Text } from '@here/components'
import { createForm, pattern, required } from '@modular-forms/solid'
import { Divider, Grid } from 'styled-system/jsx'

type UrlForm = {
	url: string
}

export const Upload = (props: {
	onLoadImage: (imageUrl: string | undefined) => void
	disabled?: boolean
}) => {
	const [form, { Form, Field: FormField }] = createForm<UrlForm>()

	const handleImageUpload = (event: Event) => {
		const target = event.target as HTMLInputElement
		if (target.files && target.files[0]) {
			const file = target.files[0]
			props.onLoadImage(URL.createObjectURL(file))
		}
	}

	const handleImageUrlSubmit = async ({ url }: UrlForm) => {
		if (!url) return

		try {
			const response = await fetch(url)
			const blob = await response.blob()
			props.onLoadImage(URL.createObjectURL(blob))
		} catch (error) {
			console.error('Error fetching image from URL:', error)
		}
	}

	return (
		<Grid gap={2}>
			<Text children="Upload an image or input your tradingview image url" />
			<Grid gap={2}>
				<FileUpload.Root
					maxFiles={1}
					onChange={handleImageUpload}
				>
					<FileUpload.Trigger>
						<Button
							disabled={props.disabled}
							colorPalette="tscGreen"
							variant="subtle"
							width={'100%'}
						>
							Upload Image
						</Button>
					</FileUpload.Trigger>
					<FileUpload.HiddenInput />
				</FileUpload.Root>
				<Form onSubmit={handleImageUrlSubmit}>
					<FormField
						name="url"
						validate={[
							required('Please enter your email.'),
							pattern(
								/^https:\/\/s3\.tradingview\.com\/snapshots\/[A-Za-z0-9]\/[A-Za-z0-9]+\.png$/,
								'Invalid URL',
							),
						]}
					>
						{(field, formFieldProps) => (
							<Field.Root invalid={!!field.error}>
								<Field.Label>Tradingview URL</Field.Label>
								<Field.Input
									type="text"
									{...formFieldProps}
									value={field.value as any}
									placeholder="Enter image URL"
								/>
								<Field.ErrorText>{field.error}</Field.ErrorText>
							</Field.Root>
						)}
					</FormField>
					<Button
						w="100%"
						mt={2}
						disabled={props.disabled}
						colorPalette="tscGreen"
						variant="subtle"
					>
						Load Image from Tradingview
					</Button>
				</Form>
			</Grid>
		</Grid>
	)
}
